import { create } from "zustand";
import { Task } from "~/types/task";

interface CompleteTaskState {
  isOpen: boolean;
  task: Task | null;
}

interface CompleteTaskActions {
  openCompleteTask: (task: Task) => void;
  closeCompleteTask: () => void;
}

export const useCompleteTask = create<CompleteTaskState & CompleteTaskActions>()(
  (set) => ({
    isOpen: false,
    task: null,
    openCompleteTask: (task: Task) =>
      set({
        isOpen: true,
        task,
      }),
    closeCompleteTask: () =>
      set({
        isOpen: false,
        task: null,
      }),
  })
);
